module.exports = __webpack_public_path__ + "img/icon-player-play.f03b8ba5.svg";